import * as React from 'react'
import CircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'

export default function CircularProgressWithLabel(props: CircularProgressProps & { value: number }) {
  return (
    <Box
      sx={{ position: 'relative', display: 'inline-flex', height: '150px', width: '140px' }}
      className='circulo-porcentaje'
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%'
        }}
      >
        <CircularProgress sx={{ color: 'rgb(0,80,48)' }} size={120} thickness={2} variant='determinate' {...props} />
        <Box
          sx={{
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Typography
            variant='caption'
            component='div'
            sx={{ color: 'rgb(0,80,48)', fontWeight: '700', fontSize: '40px' }}
          >
            {`${Math.round(props.value)}%`}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}
